import { useEffect, useState } from 'react';

const UNITS: readonly [Intl.RelativeTimeFormatUnit, number][] = [
  ['day', 86_400_000],
  ['hour', 3_600_000],
  ['minute', 60_000],
];

/** "há 3 minutos" / "3 minutes ago" / "hace 3 minutos"; abaixo de 45 s, "agora". */
export function formatAgo(instant: number, now: number, locale: string): string {
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
  const diff = instant - now;
  if (Math.abs(diff) < 45_000) return rtf.format(0, 'second');
  for (const [unit, ms] of UNITS) {
    if (Math.abs(diff) >= ms || unit === 'minute') return rtf.format(Math.round(diff / ms), unit);
  }
  return rtf.format(0, 'second');
}

/** Relógio que anda de `intervalMs` em `intervalMs`, para o "atualizado há X" não congelar. */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
